import EditorPreviewRootPage, {
    links,
    handle,
} from '~/modules/professional/page/ProfessionalPagePreview';
import { loader } from '@modules/professional/page/loaders/professional-page-preview-loader.server';

export { loader, links, handle };
export default EditorPreviewRootPage;
